"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = void 0;
var formatPrice = function formatPrice(price) {
  return parseFloat(price.toString()).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
};
exports.formatPrice = formatPrice;